import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import {
  useTimezoneSelect,
  allTimezones,
  ITimezoneOption,
} from "react-timezone-select";

const labelStyle = "original";
const timezones = {
  ...allTimezones,
  "Europe/Berlin": "Frankfurt",
};

export const TimeZonePicker = ({
  value,
  defaultValue,
  onChange,
}: {
  value: string;
  defaultValue: string | undefined;
  onChange: (tz: string) => void;
}) => {
  const { options, parseTimezone } = useTimezoneSelect({
    labelStyle,
    timezones,
  });

  const val = !value ? "Europe/London" : value;

  return (
    <FormControl
      fullWidth
      style={{
        // standard for other controls
        marginBottom: 20,
      }}
    >
      <InputLabel id="demo-simple-select-label">Timezone</InputLabel>
      <Select
        labelId="select-timezone-label"
        id="select-timezone"
        label="Timezone"
        value={val}
        defaultValue="Europe/London"
        onChange={(e) => {
          onChange(e.target.value);
        }}
      >
        {options.map((option) => (
          <MenuItem value={option.value}>{option.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
